module.exports = __webpack_public_path__ + "img/office-365-icon.b3d8aa77.svg";